<ds-form-field
    [ngClass]="[inputStyleClass, colorClass, isReadOnly ? 'sera-input-number--read-only' : 'sera-input-number']"
    [optionalText]="' '"
    [inlineConfig]="textAlign === 'left' ? { labelWidth: '25%', gutter: 'var(--ds-space-4x)', labelAlign: 'left' } : null">
    <label
        *ngIf="label"
        [class]="inputNumberLabelClass"
        ds-label
        [for]="inputId">
        {{ translateLabel ? (label | translate) : label }}
    </label>
    <input
        [title]="tooltipText"
        #inputElement
        required
        ds-input
        type="number"
        [id]="inputId"
        [ngModelOptions]="{ updateOn: 'blur' }"
        [ngModel]="value | number : decimals | noComma"
        (ngModelChange)="onValueChange($event)"
        (focus)="onFocus()"
        (blur)="onBlur($event)"
        [placeholder]="placeholder"
        [size]="'md'"
        [readonly]="isReadOnly"
        [disabled]="isDisabled"
        [min]="min"
        [max]="max" />
</ds-form-field>
